import React from 'react';

function ErrorComponent(props) {
    return (
        <div className='error'>
            
            {props.children}
        </div>
    );
}

export default ErrorComponent;